import { Injectable } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { UserService } from "@main/users";
import { NamingConvention } from "@mipro/classes/naming-convention";
import { BehaviorSubject, switchMap } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class NamingConventionService {
    public static readonly NamingConventionUpdatedEventName = "Naming Convention Updated Event Name";

    private defaultNamingConvention = <NamingConvention>{
        singularEndUserNamingConvention: "Patient",
        pluralEndUserNamingConvention: "Patients",
        singularGroupNamingConvention: "Group",
        pluralGroupNamingConvention: "Groups",
        singularOrganisationLabel: "Organisation",
        pluralOrganisationLabel: "Organisations"
    };
    private namingConvention: NamingConvention = { ...this.defaultNamingConvention };
    private namingConventionSubject = new BehaviorSubject(this.namingConvention);

    get endUserSingular() {
        return this.namingConvention.singularEndUserNamingConvention;
    }

    get endUserPlural() {
        return this.namingConvention.pluralEndUserNamingConvention;
    }

    get groupPlural() {
        return this.namingConvention.pluralGroupNamingConvention;
    }

    get groupSingular() {
        return this.namingConvention.singularGroupNamingConvention;
    }

    get organisationPlural() {
        return this.namingConvention.pluralOrganisationLabel;
    }

    get organisationSingular() {
        return this.namingConvention.singularOrganisationLabel;
    }

    get namingConvention$() {
        return this.namingConventionSubject.asObservable();
    }

    constructor(private userService: UserService, private broadcastService: BroadcastService) {
        this.broadcastService
            .on(UserService.CurrentUserChangedEventName)
            .pipe(switchMap(_ => this.userService.getLoggedUserNamingConvention()))
            .subscribe(namingConvention => this.setNamingConvention(namingConvention));
    }

    async initialize() {
        const namingConvention = await this.userService.getLoggedUserNamingConvention();
        this.setNamingConvention(namingConvention);
    }

    private setNamingConvention(namingConvention: NamingConvention) {
        this.namingConvention = namingConvention ?? this.defaultNamingConvention;
        this.broadcastService.broadcast(NamingConventionService.NamingConventionUpdatedEventName, this.namingConvention);
        this.namingConventionSubject.next(this.namingConvention);
    }
}
